import React from "react";
import { useState, useRef, useEffect, useMemo } from "react";
import {
    Box, Typography, Avatar, Chip, Button, IconButton, Grid, TextField,
    Stack, Popper, Grow, Paper, ClickAwayListener, Tabs, Tab, Menu, MenuItem, Collapse
} from "@mui/material";
import moment from "moment";
import TableComponent from "components/grid";
import StatusBadge from "components/badge/StatusBadge";
import CustomPagination from "components/CustomPagination";
import { ReactComponent as EditIcon } from "assets/icons/EditIcon.svg";
import { LuEye, LuRefreshCw, LuSearch } from "react-icons/lu";
import { BiListUl } from "react-icons/bi";
import { MdOutlineFileDownload, MdOutlineFilterAlt } from "react-icons/md";
import { FaPlus } from "react-icons/fa6";
import Select from "react-select";
import CustomButton from "components/Button";
import { useParams } from "react-router-dom";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { useGetAllContactsQuery } from "store/slices/apis/contactSlice";
// import { statusOptions, capaStatusOptions, incidentSeverityOptions, incidentTypeOptions, locationOptions, contractorOptions, responsiblePersonData } from "helpers/incidentOption";
import { usePermission } from "hooks/usePermission";
import { IRR_TRACKER_ACCESS, IRR_TRACKER_CREATE, IRR_TRACKER_EDIT, IRR_TRACKER_VIEW } from "helpers/permissionConfig";
import ProjectLastUpdatedOn from "components/ProjectLastUpdatedOn";
import { useGetLastUpdatedOnStatusQuery } from "store/slices/apis/projectStatusApiSlice";
import { useGetMasterDataQuery } from "store/slices/apis/masterConfigation";
import AddIrrView from "./addIrrView";
import EditIrrView from "./editIrrView";
import ViewIrr from "./viewIrrView";
import { useLazyGetAllIrrQuery, useLazyGetExportIRRQuery } from "store/slices/apis/irrViewTrackerSlice";
import { useGetPortfolioSummaryQuery } from "store/slices/apis/portfolioSummarySlice";
import { useGetAllProjectsQuery } from "store/slices/apis/projectApiSlice";
import { exportToExcel } from "utils/ExportToExcel";
import { closeSnackbar, openSnackbar } from "store/slices/snackbar";
import { useDispatch } from "store";

const calenderSVG = (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_894_610)">
            <path d="M12.6667 1.33333H12V0.666667C12 0.489856 11.9298 0.320286 11.8047 0.195262C11.6797 0.0702379 11.5101 0 11.3333 0C11.1565 0 10.987 0.0702379 10.8619 0.195262C10.7369 0.320286 10.6667 0.489856 10.6667 0.666667V1.33333H5.33333V0.666667C5.33333 0.489856 5.2631 0.320286 5.13807 0.195262C5.01305 0.0702379 4.84348 0 4.66667 0C4.48986 0 4.32029 0.0702379 4.19526 0.195262C4.07024 0.320286 4 0.489856 4 0.666667V1.33333H3.33333C2.4496 1.33439 1.60237 1.68592 0.97748 2.31081C0.352588 2.93571 0.00105857 3.78294 0 4.66667L0 12.6667C0.00105857 13.5504 0.352588 14.3976 0.97748 15.0225C1.60237 15.6474 2.4496 15.9989 3.33333 16H12.6667C13.5504 15.9989 14.3976 15.6474 15.0225 15.0225C15.6474 14.3976 15.9989 13.5504 16 12.6667V4.66667C15.9989 3.78294 15.6474 2.93571 15.0225 2.31081C14.3976 1.68592 13.5504 1.33439 12.6667 1.33333ZM1.33333 4.66667C1.33333 4.13623 1.54405 3.62753 1.91912 3.25245C2.29419 2.87738 2.8029 2.66667 3.33333 2.66667H12.6667C13.1971 2.66667 13.7058 2.87738 14.0809 3.25245C14.456 3.62753 14.6667 4.13623 14.6667 4.66667V5.33333H1.33333V4.66667ZM12.6667 14.6667H3.33333C2.8029 14.6667 2.29419 14.456 1.91912 14.0809C1.54405 13.7058 1.33333 13.1971 1.33333 12.6667V6.66667H14.6667V12.6667C14.6667 13.1971 14.456 13.7058 14.0809 14.0809C13.7058 14.456 13.1971 14.6667 12.6667 14.6667Z" fill="#433F5E" />
            <path d="M8 11C8.55228 11 9 10.5523 9 10C9 9.44772 8.55228 9 8 9C7.44772 9 7 9.44772 7 10C7 10.5523 7.44772 11 8 11Z" fill="#433F5E" />
            <path d="M4.66656 11C5.21885 11 5.66656 10.5523 5.66656 10C5.66656 9.44772 5.21885 9 4.66656 9C4.11428 9 3.66656 9.44772 3.66656 10C3.66656 10.5523 4.11428 11 4.66656 11Z" fill="#433F5E" />
            <path d="M11.3334 11C11.8857 11 12.3334 10.5523 12.3334 10C12.3334 9.44772 11.8857 9 11.3334 9C10.7811 9 10.3334 9.44772 10.3334 10C10.3334 10.5523 10.7811 11 11.3334 11Z" fill="#433F5E" />
        </g>
        <defs>
            <clipPath id="clip0_894_610">
                <rect width="16" height="16" fill="white" />
            </clipPath>
        </defs>
    </svg>
);

const labelTextStyle = {
    fontWeight: 500,
    fontSize: "16px",
    lineHeight: "100%",
    color: "#5F5F5F",
    fontFamily: "Outfit, sans-serif",
    mb: 1,
    mt: 1,
};


const IrrViewTracker = () => {

    const { projectId } = useParams();

    const [pageNumber, setPageNumber] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [sortOrder, setSortOrder] = useState('desc');
    const [sortBy, setSortBy] = useState('createdDate');
    const dispatch = useDispatch();


    const [open, setOpen] = useState(false);
    const [tabValue, setTabValue] = useState(0);
    const anchorRef = useRef(null);
    const [isAdd, setIsAdd] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [selectedData, setSelectedData] = useState(null);
    const [isView, setIsView] = useState(false);
    const [viewData, setViewData] = useState(null);
    const [menuAnchorEl, setMenuAnchorEl] = useState(null);
    const [menuRow, setMenuRow] = useState(null);
    const [searchTerm, setSearchTerm] = useState("");
    const [showSummary, setShowSummary] = useState(true);

    const createAccess = usePermission(IRR_TRACKER_CREATE);
    const editAccess = usePermission(IRR_TRACKER_EDIT);
    const viewAccess = usePermission(IRR_TRACKER_VIEW);

    const emptyGUID = "00000000-0000-0000-0000-000000000000";

    const [projectType, setProjectType] = useState(localStorage.getItem("projectType") || "all")

    const { data, error, isLoading, isFetching: isProjectFething, refetch } = useGetAllProjectsQuery(projectType);
    const { data: portfolioData, isFetching: portfolioLoader, isError: portfolioError } = useGetPortfolioSummaryQuery();

    const projectData = data?.data || [];
    const filteredProjectData = projectData.filter((data) => data.active == true);

    const projectOptions = (filteredProjectData || []).map(p => ({
        value: p.projectId,
        label: p.projectName,
        projectType: p.projectType,
    }));

    const portfolioOptions = (portfolioData?.data || []).map(p => ({
        value: p.portfolioName,
        label: p.portfolioName,
        projectType: p.portFolioType,
    }));

    const portfolioSelectOptions = useMemo(
        () => [
            // { projectType: "all", label: "All Portfolio" },
            ...portfolioOptions,
        ],
        [portfolioOptions]
    );

    const handlePortfolioChange = (option) => {
        const newProjectType = option?.projectType || "all";
        setProjectType(newProjectType);
        localStorage.setItem("projectType", newProjectType);

        const updatedFilters = {
            ...filters,
            Product: option?.value || "",
            ProjectId: "",
            PageNumber: 1,
        };

        setFilters(updatedFilters);
    };

    // const { data: contactsData, isLoading, error } = useGetAllContactsQuery();

    const [trigger, { data: irrData, isFetching }] = useLazyGetAllIrrQuery()


    const { data: statusDate } = useGetLastUpdatedOnStatusQuery({ ProjectId: projectId });

    useEffect(() => {
        const delayDebounceFn = setTimeout(() => {
            if (searchTerm !== filters.SearchTerm) {
                const updatedFilters = {
                    ...filters,
                    SearchTerm: searchTerm,
                    PageNumber: 1,
                };
                setFilters(updatedFilters);
                trigger(updatedFilters);
                setPageNumber(1);
            }
        }, 500);
        return () => clearTimeout(delayDebounceFn);
    }, [searchTerm]);



    const handleMenuOpen = (event, row) => {
        event.stopPropagation();
        setMenuAnchorEl(event.currentTarget);
        setMenuRow(row);
    };


    const handleMenuClose = () => {
        setMenuAnchorEl(null);
        setMenuRow(null);
    };


    const handleMenuView = () => {
        if (menuRow) {
            handleViewClick(menuRow);
        }
        handleMenuClose();
    };


    const handleMenuEdit = () => {
        if (menuRow) {
            handleEdit(menuRow);
        }
        handleMenuClose();
    };


    const [filters, setFilters] = useState({
        SortBy: sortBy,
        SortOrder: sortOrder,
        PageNumber: pageNumber,
        PageSize: pageSize,
        ProjectId: projectId,
        Product: "",
        Project: "",
        SearchTerm: ""
    });



    useEffect(() => {
        trigger(filters);
    }, []);


    const handlePageChange = (newPage) => {
        setPageNumber(newPage);
        const updatedFilters = {
            ...filters,
            PageNumber: newPage,
        };
        setFilters(updatedFilters);
        trigger(updatedFilters);
    };


    const handlePageSizeChange = (newSize) => {
        setPageSize(newSize);
        setPageNumber(1);
        const updatedFilters = {
            ...filters,
            PageSize: newSize,
            PageNumber: 1,
        };
        setFilters(updatedFilters);
        trigger(updatedFilters);
    };


    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);

        const updatedFilters = {
            ...filters,
            PageNumber: 1,
        };

        setFilters(updatedFilters);
        trigger(updatedFilters);
        setPageNumber(1);
    };


    const handleApplyFilters = () => {
        const updatedFilters = {
            ...filters,
            PageNumber: 1,
        };

        setFilters(updatedFilters);
        trigger(updatedFilters);
        setPageNumber(1);
        handleClose();
    };


    const handleReset = () => {
        const resetFilters = {
            ProjectId: projectId,
            SortBy: sortBy,
            SortOrder: sortOrder,
            PageNumber: 1,
            PageSize: 10,
            Product: "",
            Project: "",
        };
        setFilters(resetFilters);
        setProjectType("all");
        localStorage.setItem("projectType", "all");

        trigger(resetFilters);
        setPageNumber(1);
        handleClose();
    };


    const handleSelectChange = (selectedOption, fieldName) => {
        const updatedFilters = {
            ...filters,
            [fieldName]: selectedOption?.value || "",
            PageNumber: 1,
        };

        setFilters(updatedFilters);
        // trigger(updatedFilters);
        // setPageNumber(1);
    };


    const handleDateChange = (e) => {
        const { name, value } = e.target;

        let utcDate = "";
        if (value) {

            const localDate = new Date(value);
            utcDate = localDate.toISOString();
        }

        const updatedFilters = {
            ...filters,
            [name]: utcDate,
            PageNumber: 1,
        };

        setFilters(updatedFilters);
        // trigger(updatedFilters);
        // setPageNumber(1);
    };


    const handleRequestSort = (property) => {
        const isAsc = sortBy === property && sortOrder === 'asc';
        const updatedFilters = {
            ...filters,
            SortBy: property,
            SortOrder: isAsc ? 'desc' : 'asc'
        };
        setFilters(updatedFilters);
        setSortOrder(isAsc ? 'desc' : 'asc');
        setSortBy(property);
        trigger(updatedFilters);
    };


    const handleDelete = (filterType) => {
        const updatedFilters = {
            ...filters,
            [filterType]: "",
            PageNumber: 1
        };

        if (filterType === "ProjectId") {
            updatedFilters.Project = "";
        }

        if (filterType === "Product") {
            updatedFilters.ProjectId = "";
            updatedFilters.Project = "";
            setProjectType("all");
            localStorage.setItem("projectType", "all");
        }

        setFilters(updatedFilters);
        trigger(updatedFilters);
        setTabValue(0)
        setPageNumber(1);
    };


    const handleAddIrrView = () => {
        setIsAdd((prev) => !prev);
    };

    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleEdit = async (row) => {
        try {

            setSelectedData(row);
            setIsEdit((prev) => !prev);

        } catch (error) {

            console.error('Error fetching design by ID:', error);
            setIsEdit((prev) => !prev);
            setSelectedData(row);
        }
    };


    const handleEditClose = () => {
        setIsEdit((prev) => !prev);
        setSelectedData(null);
    };

    const handleViewClick = async (row) => {
        try {
            setViewData(row);
            setIsView(true);

        } catch (error) {
            setViewData(row);
            setIsView(true);
        }
    };


    const handleViewClose = () => {
        setIsView(false);
        setViewData(null);
    };

    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value);
    };


    const getCount = (ind) => {
        switch (ind) {
            // case 1: return openCount;
            // case 2: return closedCount;
            default: return 0;
        }
    }




    const highlightText = (text, highlight) => {
        if (!highlight || !text) return text;

        const regex = new RegExp(`(${highlight})`, 'gi');
        const parts = String(text).split(regex);

        return parts.map((part, index) =>
            regex.test(part) ? (
                <span
                    key={index}
                    style={{
                        backgroundColor: '#FFF3CD',
                        color: '#856404',
                        fontWeight: 'bold',
                        padding: '0 2px',
                        borderRadius: '3px'
                    }}
                >
                    {part}
                </span>
            ) : part
        );
    };



    const handleToggleSummary = () => {
        setShowSummary((prev) => !prev);
    };

    const renderCostWithPost = (cost, post) => {
        if (!cost && !post) return "-";

        const formattedCost = cost ? `${cost} Cr` : "";
        const formattedPost = post ? `${post}` : "";

        return `${formattedCost} ${formattedPost}`;
    };
    const openNotification = (msg, type = "error", duration = 3000) => {
        dispatch(
            openSnackbar({
                open: true,
                message: msg,
                variant: 'alert',
                alert: {
                    color: type
                },
                close: false
            })
        );
        setTimeout(() => dispatch(closeSnackbar()), duration);
    };


    const ALL_EXPORT_COLUMNS = [

        { name: "Product", field: "product" },
        { name: "Project", field: "project" },
        {
            name: "Total Project Cost (INR Cr) UnderWriting",
            field: "totalProjectCostUnderWriting",
        },
        {
            name: "Total Project Cost (INR Cr) Current/Actual",
            field: "totalProjectCostCurrentActual",
        },
        { name: "Project IRR (%)", field: "projectIrrPercent" },
        { name: "Equity IRR (%)", field: "equityIrrPercent" },
    ];


    const [triggerExport, { isFetching: isExporting }] = useLazyGetExportIRRQuery();


    const handleExportExcel = async () => {
        try {
            const exportFilters = {
                ...filters,
                PageNumber: 1,
                PageSize: 5000,
            };

            const response = await triggerExport(exportFilters).unwrap();
            const rows = response?.data?.list || [];

            if (!Array.isArray(rows) || rows.length === 0) {
                openNotification("No data available to export", "warning");
                return;
            }

            const formattedData = rows.map((row, index) => {
                const rowData = { "S.No": index + 1 };

                ALL_EXPORT_COLUMNS.forEach(col => {
                    const field = col.field;
                    let value = "N/A";
                    const raw = row[field];
                    value = raw ?? "N/A";
                    rowData[col.name] = value;
                });

                return rowData;
            });

            exportToExcel(formattedData, "IRR_Data", "IRR Tracker");

            openNotification("Excel exported successfully", "success");
        } catch (error) {
            console.error("Export error:", error);
            openNotification("Failed to export Excel", "error");
        }
    };


    const columns = [
        {
            name: "",
            field: "actions",
            width: "10px",
            sticky: true,
            renderer: (row) => (
                <>
                    {(viewAccess || editAccess) &&
                        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                            <IconButton
                                size="small"
                                onClick={(e) => handleMenuOpen(e, row)}
                            >
                                <MoreVertIcon fontSize="small" />
                            </IconButton>
                        </Box>
                    }
                </>

            ),
        },
        // {
        //     name: "ID",
        //     field: "customId",
        //     width: "100px",
        //     sticky: true,
        // },
        {
            name: "Product",
            field: "product",
            width: "120px",
            sticky: true,
            renderer: (row) => row?.product ? highlightText(row.product, searchTerm) : "-",
        },

        {
            name: "Project",
            field: "project",
            width: "150px",
            renderer: (row) => row?.project ? highlightText(row.project, searchTerm) : "-",
        },
        {
            name: "Total Project Cost (INR Cr) UnderWriting",
            field: "totalProjectCostUnderWriting",
            width: "150px",
            renderer: (row) =>
                renderCostWithPost(
                    row.totalProjectCostUnderwriting,
                    row.totalProjectPostUnerwriting
                ),
        },

        {
            name: "Total Project Cost (INR Cr) Current/Actual",
            field: "totalProjectCostCurrentActual",
            width: "150px",
            renderer: (row) =>
                renderCostWithPost(
                    row.totalProjectCostCurrentActual,
                    row.totalProjectPostCurrentActual
                ),
        },
        {
            name: "Project IRR (%)",
            field: "projectIrrPercent",

        },
        {
            name: "Equity IRR (%)",
            field: "equityIrrPercent",

        },

    ];


    return (
        <>
            <Grid container spacing={2} sx={{ mt: '20px', p: 2 }}>
                <Grid size={12} container alignItems="center" justifyContent="space-between">
                    <Typography variant="h5" sx={{ mb: 1 }}>
                        IRR View Tracker
                    </Typography>
                    {statusDate?.incident && <ProjectLastUpdatedOn date={statusDate?.incident} />}
                </Grid>

                <Grid size={12}>
                    <Box
                        sx={{
                            width: "100%",
                            borderBottom: "2px solid #ECECEC",
                            overflowX: "auto",
                            whiteSpace: "nowrap",
                            p: 0,
                            display: "flex", alignItems: "center", justifyContent: 'space-between',
                            "-webkit-overflow-scrolling": "touch",
                        }}
                    >
                        <Tabs
                            value={tabValue}
                            onChange={handleTabChange}
                            TabIndicatorProps={{ style: { display: "none" } }}
                            variant="scrollable"
                            scrollButtons={false}
                            sx={{
                                justifyContent: "flex-start !important",
                                alignItems: "flex-start",
                                "& .MuiTabs-flexContainer": {
                                    justifyContent: "flex-start !important",
                                    gap: "30px",
                                },
                            }}
                        >
                            {["All"].map((label, index) => {

                                return (
                                    <Tab
                                        key="0"
                                        label={
                                            <Box sx={{ display: "flex", alignItems: "center", gap: "6px" }}>
                                                <Typography
                                                    sx={{
                                                        fontWeight: 500,
                                                        fontSize: "14px",
                                                        lineHeight: "100%",
                                                        color: tabValue === index ? "#0E73F6" : "#7E7E7E",
                                                        fontFamily: "Outfit, sans-serif"
                                                    }}
                                                >
                                                    {label}
                                                </Typography>
                                                {index != 0 &&
                                                    <Chip
                                                        label={getCount(index)}
                                                        sx={{
                                                            height: "20px",
                                                            fontSize: "14px",
                                                            fontWeight: 500,
                                                            lineHeight: 1,
                                                            backgroundColor: "#E5E9EB",
                                                            color: "#5F5F5F",
                                                        }}
                                                    />
                                                }

                                            </Box>
                                        }
                                        sx={{
                                            textTransform: "none",
                                            minWidth: "auto",
                                            paddingBottom: "14px",
                                            paddingLeft: 0,
                                            paddingRight: 0,
                                            borderBottom: tabValue === index ? "2px solid #0E73F6" : "2px solid transparent",
                                        }}
                                    />
                                );
                            })}
                        </Tabs>
                        {createAccess &&
                            <CustomButton
                                label="Create IRR"
                                startIcon={<FaPlus />}
                                color="primary"
                                onClick={handleAddIrrView}
                                sx={{
                                    backgroundColor: "#2563EB",
                                    fontFamily: 'Outfit',
                                    fontWeight: 500,
                                    fontSize: '14px',
                                    lineHeight: '100%',
                                    letterSpacing: '0px',
                                }}
                            />
                        }
                    </Box>
                </Grid>


                <Grid size={12}>
                    <Grid container>
                        <Grid size={{ md: 8, sm: 12 }}>
                            <Stack
                                direction="row"
                                spacing={1}
                                flexWrap="wrap"
                                sx={{
                                    padding: "8px 0",
                                    alignItems: "center",
                                    minHeight: "40px"
                                }}
                            >

                                {filters.Product && (
                                    <Chip
                                        label={
                                            <Typography variant="body2">
                                                <strong style={{ color: '#0E73F6' }}>Product:</strong>{" "}
                                                <span style={{ fontWeight: 400, color: "#6B7280" }}>
                                                    {filters.Product}
                                                </span>
                                            </Typography>
                                        }
                                        sx={{
                                            backgroundColor: "rgba(25, 118, 210, 0.08)",
                                            border: 0
                                        }}
                                        variant="outlined"
                                        onDelete={() => handleDelete('Product')}
                                    />
                                )}

                                {filters.ProjectId && (
                                    <Chip
                                        label={
                                            <Typography variant="body2">
                                                <strong style={{ color: '#0E73F6' }}>Project:</strong>{" "}
                                                <span style={{ fontWeight: 400, color: "#6B7280" }}>
                                                    {filters.Project}
                                                </span>
                                            </Typography>
                                        }
                                        sx={{
                                            backgroundColor: "rgba(25, 118, 210, 0.08)",
                                            border: 0
                                        }}
                                        variant="outlined"
                                        onDelete={() => handleDelete('ProjectId')}
                                    />
                                )}

                            </Stack>
                        </Grid>


                        <Grid size={{ md: 4, sm: 12 }}>
                            <Box
                                sx={{
                                    display: "flex",
                                    flexDirection: { md: "row", xs: "column" },
                                    alignItems: { md: "center", xs: "flex-start" },
                                    justifyContent: 'end',
                                    p: "8px 0px"
                                }}
                            >
                                <TextField
                                    placeholder="Search By Product, Project ..."
                                    value={searchTerm}
                                    onChange={handleSearchChange}
                                    variant="outlined"
                                    size="small"
                                    InputProps={{
                                        startAdornment: <LuSearch style={{ marginRight: '8px', color: '#6B7280' }} />,
                                    }}
                                    sx={{
                                        minWidth: { md: '380px', xs: "auto" },
                                        backgroundColor: '#fff',
                                        borderRadius: '20px',
                                        '& .MuiOutlinedInput-root': { borderRadius: '20px' },
                                        '& .MuiInputBase-input::placeholder': {
                                            fontSize: '0.9rem',
                                        }
                                    }}
                                    type="search"
                                />
                                <IconButton
                                    ref={anchorRef}
                                    onClick={handleToggle}
                                >
                                    <MdOutlineFilterAlt size={24} color="#48535B" />
                                </IconButton>


                                <Popper
                                    open={open}
                                    anchorEl={anchorRef.current}
                                    placement="bottom-end"
                                    transition
                                    disablePortal={false}
                                    sx={{ zIndex: 2000 }}
                                >
                                    {({ TransitionProps }) => (
                                        <Grow {...TransitionProps}>
                                            <Paper
                                                sx={{
                                                    mt: 1,
                                                    p: 2,
                                                    borderRadius: 1,
                                                    boxShadow: "0px 4px 20px rgba(7, 7, 7, 0.08)",
                                                    width: 600,
                                                }}
                                            >
                                                <ClickAwayListener onClickAway={handleClose}>
                                                    <Box>
                                                        <Grid container spacing={2}>

                                                            <Grid size={6}>
                                                                <Typography sx={labelTextStyle}>
                                                                    Product
                                                                </Typography>

                                                                <Select
                                                                    name="Product"
                                                                    options={portfolioSelectOptions}
                                                                    value={
                                                                        portfolioSelectOptions.find(
                                                                            (opt) => opt.value === filters.Product
                                                                        ) || null
                                                                    }
                                                                    onChange={handlePortfolioChange}
                                                                    placeholder="Select Portfolio"
                                                                />
                                                            </Grid>

                                                            <Grid size={6}>
                                                                <Typography sx={labelTextStyle}>
                                                                    Project
                                                                </Typography>

                                                                <Select
                                                                    name="Project"
                                                                    options={[{ value: emptyGUID, label: "All Projects" }, ...projectOptions]}
                                                                    value={
                                                                        [{ value: emptyGUID, label: "All Projects" }, ...projectOptions]
                                                                            .find(opt => opt.value === filters.ProjectId) || null
                                                                    }
                                                                    onChange={(option) => {
                                                                        const updatedFilters = {
                                                                            ...filters,
                                                                            ProjectId: option?.value || "",
                                                                            Project: option?.label || "",
                                                                            PageNumber: 1
                                                                        };
                                                                        setFilters(updatedFilters);
                                                                    }}
                                                                    placeholder="Select Project"
                                                                />
                                                            </Grid>

                                                            <Grid size={12}>
                                                                <Box
                                                                    sx={{
                                                                        display: "flex",
                                                                        justifyContent: "flex-end",
                                                                        alignItems: "center",
                                                                    }}
                                                                >
                                                                    <Button onClick={handleReset}
                                                                        sx={{
                                                                            textTransform: "none",
                                                                            color: "#F15744",
                                                                            fontSize: "14px",
                                                                            lineHeight: "100%",
                                                                            fontFamily: "Outfit, sans-serif",
                                                                            borderRadius: "25px",
                                                                            fontWeight: 500,
                                                                            px: "20px",
                                                                            py: "15px",
                                                                        }}>
                                                                        Reset
                                                                    </Button>
                                                                    <Button
                                                                        type="button"
                                                                        onClick={handleApplyFilters}
                                                                        variant="contained"
                                                                        sx={{
                                                                            backgroundColor: "#2563EB",
                                                                            borderRadius: "25px",
                                                                            textTransform: "none",
                                                                            fontWeight: 500,
                                                                            fontSize: "14px",
                                                                            lineHeight: "100%",
                                                                            fontFamily: "Outfit, sans-serif",
                                                                            color: "#FFFFFF",
                                                                            px: "20px",
                                                                            py: "15px",
                                                                        }}
                                                                    >
                                                                        Apply
                                                                    </Button>
                                                                </Box>
                                                            </Grid>
                                                        </Grid>
                                                    </Box>
                                                </ClickAwayListener>
                                            </Paper>
                                        </Grow>
                                    )}
                                </Popper>

                                <IconButton
                                    onClick={() => { trigger(filters); }}
                                >
                                    <LuRefreshCw size={20} color="#48535B" />
                                </IconButton>
                                <IconButton onClick={handleExportExcel} disabled={isExporting}>
                                    <MdOutlineFileDownload size={24} color="#48535B" />
                                </IconButton>
                            </Box>
                        </Grid>
                    </Grid>
                </Grid>


                <Grid size={12}>
                    <TableComponent
                        columns={columns}
                        data={irrData?.data?.list || []}
                        createSortHandler={handleRequestSort}
                        isLoading={isFetching}
                        order={sortOrder}
                        orderBy={sortBy}

                    />
                    <Menu
                        anchorEl={menuAnchorEl}
                        open={Boolean(menuAnchorEl)}
                        onClose={handleMenuClose}
                        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                        transformOrigin={{ vertical: "top", horizontal: "right" }}
                        PaperProps={{
                            elevation: 0,
                            sx: {
                                mt: 1,
                                borderRadius: "3px",
                                minWidth: 140,
                                border: "1px solid #E5E9EB",
                                boxShadow: "0px 10px 30px rgba(15, 23, 42, 0.12)",
                                overflow: "hidden",
                            },
                        }}
                        MenuListProps={{
                            sx: {
                                py: 0.5,
                            },
                        }}
                    >
                        {viewAccess && <MenuItem
                            onClick={handleMenuView}
                            sx={{
                                fontFamily: "Outfit, sans-serif",
                                fontSize: "14px",
                                fontWeight: 400,
                                px: 1.5,
                                py: 1,
                                display: "flex",
                                alignItems: "center",
                                gap: 1,
                                color: "#111827",
                                "&:hover": {
                                    backgroundColor: "#F6F8F9",
                                },
                            }}
                        >
                            <LuEye size={16} style={{ color: "#4B5563" }} />
                            <span>View</span>
                        </MenuItem>
                        }
                        {editAccess && <MenuItem
                            onClick={handleMenuEdit}
                            sx={{
                                fontFamily: "Outfit, sans-serif",
                                fontSize: "14px",
                                fontWeight: 400,
                                px: 1.5,
                                py: 1,
                                display: "flex",
                                alignItems: "center",
                                gap: 1,
                                color: "#111827",
                                "&:hover": {
                                    backgroundColor: "#F6F8F9",
                                },
                            }}
                        >
                            <EditIcon style={{ width: 14, height: 14 }} />
                            <span>Edit</span>
                        </MenuItem>
                        }
                    </Menu>

                    <CustomPagination
                        totalCount={irrData?.totalRecords || 0}
                        pageSize={pageSize}
                        page={pageNumber}
                        onPageChange={handlePageChange}
                        setCurrentPage={setPageNumber}
                        onPageSizeChange={handlePageSizeChange}
                    />
                </Grid>
            </Grid>
            {isAdd && <AddIrrView open={isAdd} handleClose={handleAddIrrView} />}
            {isEdit && <EditIrrView open={isEdit} handleClose={handleEdit} rowData={selectedData} />}
            {isView && <ViewIrr open={isView} handleClose={handleViewClose} rowData={viewData} />}
        </>
    );
}

export default IrrViewTracker;